"use client";

import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { useCreateFavoriteQueryMutation } from "@/services/it/updates/query-favorites";
import { toast } from "@/components/ui/use-toast";
import { MESSAGES } from "../../utils/messages";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";

interface FormData {
  query: string;
  query_nickname: string;
}
const SaveNewScript = () => {
  const { register, handleSubmit, reset, watch } = useForm<FormData>();
  const [createQuery, { isLoading: IsCreateLoading }] =
    useCreateFavoriteQueryMutation();
  const { handleModal } = useDialogModal();

  const handleSubmitQuery = async (data: {
    query: string;
    query_nickname: string;
  }) => {
    try {
      await createQuery({
        query: data.query,
        query_nickname: data.query_nickname,
      }).unwrap();

      toast(MESSAGES.CREATE_FAVORITE.SUCCESS);
      reset();
      handleModal({
        isOpen: false,
      });
    } catch (error) {
      toast(MESSAGES.CREATE_FAVORITE.ERROR);
    }
  };

  return (
    <div className="md:min-w-[400px]">
      <form onSubmit={handleSubmit(handleSubmitQuery)}>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Input
              className="font-consolas w-full bg-[#fff] border-black/20 border rounded-lg px-5 py-2 focus:outline-none focus:border-2 focus:border-[#000000]/40"
              placeholder="Apelido/Status da Query"
              {...register("query_nickname")}
              disabled={IsCreateLoading}
            />
          </div>
          <div className="grid gap-2">
            <Textarea
              id="query"
              placeholder={`UPDATE TABELA 
SET CAMPO1 = 100
WHERE CAMPO1 = 1000;`}
              {...register("query")}
              disabled={IsCreateLoading}
              className="min-h-[100px] font-mono"
            />
          </div>
        </div>
        <div className="flex items-center justify-end">
          <Button
            className="rounded-md"
            type="submit"
            disabled={IsCreateLoading || watch("query")?.length === 0}
          >
            Salvar Query
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SaveNewScript;
